import { opaccAjaxPlugin } from '../opacc.static.js';
import { articleMessages } from '../messages/opacc.messages.js';

/** @module general */

/**
 *  Tabs / Accordions auf- und zuklappen
 */
export class OpaccTabs {
	constructor() {
		this.wrapperElement = document.querySelector('.content');
		this.tabsModule = this.wrapperElement.querySelectorAll('.opc-tabs:not([data-op-target])');
		this.tabs = this.wrapperElement.querySelectorAll('.opc-tabs[data-op-target]');
		this.allTabs = [...this.tabsModule, ...this.tabs];
		this.messages = Object.assign({}, articleMessages);

		if (this.tabs.length > 0) {
			this.initialLoadAllTabs()
				.then(() => {
					this.switchLayout();
				});
		}
		if (this.tabsModule.length > 0) {
			window.addEventListener('load', () => this.switchLayout(), false);
		}

		if (this.allTabs.length > 0) {
			let timer;
			window.removeEventListener('resize', () => this.resizeIntervall(timer));
			window.addEventListener('resize', () => this.resizeIntervall(timer));
		}
	}

	/**
	 *
	 *
	 * @param {*} timer
	 */
	resizeIntervall(timer) {
		clearTimeout(timer);
		timer = setTimeout(() => {
			this.switchLayout();
		}, 200);
	}

	/**
	 *
	 *
	 * @returns {*}
	 */
	initialLoadAllTabs() {
		let allSections = [];
		Array.from(this.tabs).forEach(elem => {
			allSections.push(new Promise((resolve) => {
				let url = elem.dataset.opTarget;
				if(url){
					opaccAjaxPlugin.fetchAsynGetForm(url, this.refreshResultTab.bind(this, true, elem, resolve), this.getDefaultErrorFnc, true);
				}
			}));
		});
		return Promise.all(allSections);
	}

	/**
	 * Events im DOM löschen / registrieren anhand der ermittelten Darstellung (Tabs oder Accordion)
	 *
	 */
	setListTypeEvents() {
		for (let type of Array.from(this.allTabs)) {
			let opLoadAll = type.querySelector('[data-op-loadall]');
			let opType = {
				listType: type.dataset.opType,
				listContentWrapper: type.querySelector('.tab-content-wrapper'),
				loadAll: opLoadAll ? (opLoadAll.dataset.opLoadall).toLowerCase() === 'true' : false
			};
			if (opType.listType === 'tabs' && type.querySelector('.tab-list')) {
				opType.listSelector = type.querySelector('.tab-list').querySelectorAll('li');
				type.removeEventListener('click', e => this.toggleAccordion(opType, e));
				type.removeEventListener('click', e => this.toggleTabs(opType, e));
				type.addEventListener('click', e => this.toggleTabs(opType, e));
					if (opType.loadAll) {
						Array.from(opType.listSelector).forEach(tab => {
							let contentTab = tab.querySelector('[href]').hash;
							if (contentTab) {
								let tab = type.querySelector(contentTab);
								this.getAsynContent(tab);
							}
						});
					} else {
						let url = type.querySelector('.is-active [href]');
						if(url){
							let activeContentTab = url.hash;
							if (activeContentTab) {
								let tab = type.querySelector(activeContentTab);
								this.getAsynContent(tab);
							}
						}
					}
			} else if (opType.listType === 'accordion') {
				opType.listSelector = opType.listContentWrapper.children;
				type.removeEventListener('click', e => this.toggleTabs(opType, e));
				type.removeEventListener('click', e => this.toggleAccordion(opType, e));
				type.addEventListener('click', e => this.toggleAccordion(opType, e));
			}
		}
	}

	/**
	 *
	 *
	 * @param {*} opType
	 * @param {*} e
	 * @returns {*}
	 */
	toggleTabs(opType, e) {
		// return if click is in connectTypeTabs-Content
		if (!e.target.closest('.tab-list')) {
			return;
		}

		let anker = e.target;
		if (anker.hash) {
			e.preventDefault();

			// check if clicked Target is in current tablist
			if (Array.from(opType.listContentWrapper.children).find(el => el.id == anker.hash.substr(1))) {
				if (opType.listContentWrapper.querySelector(anker.hash)) {
					// remove 'is-active' class on all tabs inside wrapper
					Array.from(opType.listSelector).forEach(item => {
						item.classList.remove('is-active');
					});

					// add 'is-active' to clicked element
					e.target.parentElement.classList.add('is-active');

					Array.from(opType.listContentWrapper.children).forEach(elem => {
						elem.classList.remove('is-active');
						// Add 'is-active' class on clicked element and content-element
						if (elem.id == anker.hash.substr(1)) {
							elem.classList.add('is-active');
							if (!elem.querySelector('.tab-body').childElementCount > 0) {
								this.getAsynContent(elem);
							}
						}
					});
				}
			}
		}
	}

	/**
	 *
	 *
	 * @param {*} opType
	 * @param {*} e
	 * @returns {*}
	 */
	toggleAccordion(opType, e) {
		// toggle only if click is on head
		if (!e.target.closest('.tab-head')) {
			return;
		}

		// remove 'is-active' class on all accordions
		for (let item of Array.from(opType.listSelector)) {
			e.preventDefault();
			// get tabList for toggling active-state
			let tabList = e.currentTarget.querySelector(`[href="#${item.id}"]`).parentElement;

			let relatedTabs = e.currentTarget.querySelector('.tab-content-wrapper').children;
			tabList.classList.remove('is-active');

			if (Array.from(relatedTabs).find(el => el == e.target.closest('.tab-content-inner'))) {
				Array.from(relatedTabs).forEach(tab => {
					tab.classList.remove('is-active');

					if (tab === e.target.closest('.tab-content-inner')) {
						tab.classList.add('is-active');
						tabList.classList.add('is-active');
						if (!tab.querySelector('.tab-body').childElementCount > 0) {
							this.getAsynContent(tab);
						}
					}
				});
			}
		}
	}

	/**
	 *
	 *
	 * @param {*} elem
	 * @returns {*}
	 */
	getAsynContent(elem) {
		return new Promise(resolve => {
			let url = elem.dataset.opTarget;
			if(url){
				opaccAjaxPlugin.fetchAsynGetForm(url, this.refreshResultTab.bind(this, false, elem, resolve), this.getDefaultErrorFnc, true);
			}
		});
	}

	/**
	 *
	 *
	 * @param {*} replaceAll
	 * @param {*} elem
	 * @param {*} resolve
	 * @param {*} response
	 */
	refreshResultTab(replaceAll, elem, resolve, response) {
		if (elem && response.success) {
			let targetSelector = elem;

			if (replaceAll) {
				targetSelector.innerHTML = response.dataAsHtml;
			} else {
				let htmlObj = document.createElement('div');
				htmlObj.innerHTML = response.dataAsHtml;
				let htmlObjList = htmlObj.querySelector('.opc-article-list');
				let htmlObjSpec = htmlObj.querySelector('.opc-art-spec');

				if (htmlObjList) {
					this.refreshContentWrapper(htmlObjList, targetSelector, htmlObj);
				}
				if (htmlObjSpec) {
					this.refreshContentWrapper(htmlObjSpec, targetSelector, htmlObj);
				}
			}
			resolve();
			this.firePseudoChangeEvent();
		}
	}

	/**
	 *
	 *
	 * @param {*} contentWrapper
	 * @param {*} targetSelector
	 * @param {*} htmlObj
	 */
	refreshContentWrapper(contentWrapper, targetSelector, htmlObj) {
		if (contentWrapper) {
			if (contentWrapper.hasChildNodes()) {
				targetSelector.querySelector('.tab-body').innerHTML = htmlObj.innerHTML;
			}
			else {
				let emptyInfo = document.createElement('div');
				emptyInfo.classList.add('opc-message');
				emptyInfo.dataset.opType = 'info';
				emptyInfo.innerHTML = this.messages.messageEmpty.text;
				targetSelector.querySelector('.tab-body').appendChild(emptyInfo);
			}
		}
	}

	/**
	 * Darstellung ändern Tabs <--> Accordions
	 *
	 */
	switchLayout() {
		const tabBreakPoint = this.allTabs[0].offsetWidth;
		let tabWidth = this.getItemWidth() || 0;

		Array.from(this.allTabs).forEach((tab) => {
			if (tab.dataset.opTypeFix === 'true') {
				return;
			}
			let showContentAsTabs = tab.dataset.opType === 'tabs';

			if (tabWidth > tabBreakPoint) {
				showContentAsTabs = false;
			}
			if (showContentAsTabs) {
				tab.dataset.opType = 'tabs';
			} else {
				tab.dataset.opType = 'accordion';
			}
		});
		this.setListTypeEvents();
	}

	/**
	 * Breite der Tab-Gruppen ermitteln
	 *
	 * @returns {number} Breiteste Tab-Gruppe in pixel
	 */
	getItemWidth() {
		let elements = [];

		Array.from(this.allTabs).forEach(tab => {
			if (tab.dataset.opType === 'tabs') {
				let opType =  tab.querySelectorAll('.tab-list > li');
				let itemWidth = 0;
				Array.from(opType).forEach(item => {
					itemWidth += item.clientWidth;
				});
				elements.push(itemWidth);
			}
		});

		let highestWidth = elements.sort((a, b) =>  b - a);
		return highestWidth[0];
	}


	/**
	 * Change-Event triggern, um asynchrone Change-Operationen auszuführen
	 * @private
	 * @ignore
	 */
	firePseudoChangeEvent() {
		let triggerEvent = new Event('change');
		document.querySelector('.content').dispatchEvent(triggerEvent);
	}
}